import React, { useEffect, useState } from "react";

const PLAYER_THEME_STORAGE_KEY = "lip_player_theme";
const VALID_THEMES = ["anger", "cinematic", "cool"];

function getSavedTheme() {
  const saved =
    typeof window !== "undefined"
      ? window.localStorage.getItem(PLAYER_THEME_STORAGE_KEY)
      : null;

  return VALID_THEMES.includes(saved) ? saved : "anger";
}

export default function Footer() {
  const year = new Date().getFullYear();
  const [themeKey, setThemeKey] = useState(getSavedTheme);

  const DISCORD_URL = "https://discord.gg/8TjDQV6rQS";
  const YOUTUBE_URL = "https://www.youtube.com/@LightIdeaProductions";

  useEffect(() => {
    const syncTheme = (event) => {
      const nextTheme =
        event?.detail?.themeKey ||
        window.localStorage.getItem(PLAYER_THEME_STORAGE_KEY);

      setThemeKey(VALID_THEMES.includes(nextTheme) ? nextTheme : "anger");
    };

    window.addEventListener("player-theme-change", syncTheme);
    window.addEventListener("storage", syncTheme);

    return () => {
      window.removeEventListener("player-theme-change", syncTheme);
      window.removeEventListener("storage", syncTheme);
    };
  }, []);

  return (
    <footer
      className="mt-auto border-t text-white transition-[background-color,border-color] duration-700 ease-in-out"
      style={{
        backgroundColor: "var(--footer-bg, #4c0101)",
        borderColor: "rgba(255,255,255,0.10)",
      }}
      data-theme={themeKey}
    >
      <div className="flex flex-col gap-3 px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-sm text-gray-300">
          © {year} Light Idea Productions. All rights reserved.
        </p>

        <div className="flex items-center gap-4">
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="Discord"
            className="flex items-center justify-center text-gray-300 transition hover:text-white"
            title="Discord"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="block"
            >
              <path d="M19.54 0.92A19.6 19.6 0 0 0 14.9 0c-.2.36-.43.84-.59 1.22a18.2 18.2 0 0 0-4.62 0C9.54.84 9.31.36 9.1 0A19.6 19.6 0 0 0 4.46.92C1.54 5.24.78 9.45 1.16 13.6c1.93 1.43 3.8 2.3 5.64 2.86.45-.61.85-1.26 1.19-1.94-.65-.25-1.27-.55-1.86-.9.16-.12.31-.25.46-.38 3.59 1.68 7.49 1.68 11.04 0 .15.13.3.26.46.38-.6.35-1.22.65-1.87.9.34.68.74 1.33 1.19 1.94 1.85-.56 3.72-1.43 5.65-2.86.45-4.8-.76-8.97-3.64-12.68ZM8.02 12.94c-1.08 0-1.96-.99-1.96-2.21s.87-2.22 1.96-2.22c1.1 0 1.98 1 1.96 2.22 0 1.22-.87 2.21-1.96 2.21Zm7.96 0c-1.08 0-1.96-.99-1.96-2.21s.87-2.22 1.96-2.22c1.1 0 1.98 1 1.96 2.22 0 1.22-.86 2.21-1.96 2.21Z" />
            </svg>
          </a>

          <a
            href={YOUTUBE_URL}
            target="_blank"
            rel="noreferrer"
            aria-label="YouTube"
            className="flex items-center justify-center text-gray-300 transition hover:text-white"
            title="YouTube"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="block"
            >
              <path d="M23.5 6.2s-.2-1.7-.8-2.5c-.8-1-1.7-1-2.1-1.1C17.7 2.2 12 2.2 12 2.2h0s-5.7 0-8.6.4c-.4.1-1.3.1-2.1 1.1-.6.8-.8 2.5-.8 2.5S0 8.2 0 10.1v1.8c0 1.9.5 3.9.5 3.9s.2 1.7.8 2.5c.8 1 1.9 1 2.3 1.1 1.7.2 7.4.4 8.4.4 0 0 5.7 0 8.6-.4.4-.1 1.3-.1 2.1-1.1.6-.8.8-2.5.8-2.5s.5-2 .5-3.9v-1.8c0-1.9-.5-3.9-.5-3.9ZM9.6 14.6V7.9l6.3 3.4-6.3 3.3Z" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}
